import {useParams} from 'react-router'

type RouteProps<Key extends string> = {
  render: (params: {
    [key in Key]: string
  }) => JSX.Element | null
}

export const RouteParams = <Key extends string>({render}: RouteProps<Key>) => {
  const pathParams = useParams<Key>() as {[key in Key]: string}

  return render(pathParams)
}
